var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.7967C1 16.9814 3.30351 14.5834 6.43406 14.1398L6.71604 14.0998C9.22282 13.7445 11.7772 13.7445 14.284 14.0998L14.5659 14.1398C17.6965 14.5834 20 16.9814 20 19.7967C20 21.0136 18.8892 22 17.519 22H3.48103C2.1108 22 1 21.0136 1 19.7967Z",
    stroke: "url(#paint0_linear_151_37340)",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 5.59375C16.0417 8.13081 13.5606 10.1875 10.5 10.1875C7.43945 10.1875 4.95836 8.13081 4.95836 5.59375C4.95836 3.05669 7.43945 1 10.5 1C13.5606 1 16.0417 3.05669 16.0417 5.59375Z",
    stroke: "url(#paint1_linear_151_37340)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_151_37340",
    x1: 10.5,
    y1: 1,
    x2: 10.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D64242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_151_37340",
    x1: 10.5,
    y1: 1,
    x2: 10.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D64242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.8b8333eb6eb6dceb41bf817692e11dc5.svg";
export { ForwardRef as ReactComponent };